import axiosInstance from 'src/utils/axios';
import { useQuery } from '@tanstack/react-query';
import { SOCIAL_MANAGER_CHANNEL_LIST } from 'src/constants/queryKeys';

export const networkCreateSocialManagerChannel = async (socialManagerChannel) => {
  const res = await axiosInstance.post('/SocialManagerChannel/Insert', socialManagerChannel);
  return res;
};
export const networkUpdateSocialManagerChannel = async (id, socialManagerChannel) => {
  const res = await axiosInstance.post(`/SocialManagerChannel/Update/${id}`, socialManagerChannel);
  return res;
};
export const networkRemoveSocialManagerChannel = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerChannel/Remove/${id}`);
  return res;
};
export const networkInfoSocialManagerChannel = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerChannel/Info/${id}`);
  return res;
};
export const networkGetListSocialManagerChannel = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`/SocialManagerChannel/List/${pageIndex}/${pageSize}`, payload);
  return res;
};
export function useFetchSocialManagerChannelList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SOCIAL_MANAGER_CHANNEL_LIST, pageIndex, pageSize],
    queryFn: () => networkGetListSocialManagerChannel(payload, pageIndex, pageSize),
  });
}
